import React, { Component } from 'react';
import SelectInputNarrow from '../common/SelectInputNarrow';
import ProductList from './ProductList';
import Spacer from '../common/Spacer';
import Option from '../common/Option';
import ListItem  from './ListItem';
import Preloader from '../common/Preloader';

import {api} from '../services';
import {addMixables,removeMixables,addPreparations,removePreparations,selectPreparation,selectMixable} from '../actions';

import { connect } from 'react-redux'

import './third-page.css';

class ThirdPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      products:[],
      loading:false
    };
    this.changePreparation = this.changePreparation.bind(this);
    this.changeMix = this.changeMix.bind(this);
  }

  componentDidMount(){
    let prepId = this.props.selectedPreparation.value;
    let mixId = this.props.selectedMixable.value;

    if(prepId && mixId){
      api.getMixingGuide(prepId,mixId).then((preparations) => {
          this.setState({ products: [...preparations] });
      });
    }
  }

  //Get the categories that you can mix with the substance / preparation
  changePreparation(event){
    let prep = this.props.preparations[event.target.value];
    this.props.dispatch(selectPreparation(prep));
    this.props.dispatch(removeMixables(prep));
    this.setState({ products: [] });

    api.subcategoriesForPreparation(prep.value).then((mixables) => {
        this.props.dispatch(addMixables(mixables))
    });
  }

  changeMix(event){
    let mixable = this.props.mixables[event.target.value];
    let selectedPreparation = this.props.selectedPreparation;
    this.props.dispatch(selectMixable(mixable));

    api.getMixingGuide(selectedPreparation.value, mixable.value).then((preparations) => {
        this.setState({ products: [...preparations] });
    });
  }

  render() {

    let preparations = this.props.preparations;
    let mixables = this.props.mixables;
    let selectedMixable = this.props.selectedMixable;
    let selectedPreparation = this.props.selectedPreparation;

    let prepIndex = preparations.findIndex(prep => prep.value==selectedPreparation.value);
    let mixIndex = mixables.findIndex(mix => mix.value==selectedMixable.value);

    let loading = this.state.loading;

    return (
      <div className="third-page">
          <h2 className="third-page-title">Blandningstabell för</h2>
          <div className="third-page-form-container">

          {loading && <Preloader />}

            <SelectInputNarrow value={prepIndex} change={this.changePreparation}>
                {Object.entries(selectedMixable).length === 0 && (
                      <Option placeholder value={0} name="Välj preparat" />
                )}
                {preparations.map((cat,index) => (
                  <Option key={cat.value} value={index} name={cat.text} />
                ))}
            </SelectInputNarrow>

            <h3 className="and-separator">och</h3>

            <SelectInputNarrow value={mixIndex} change={this.changeMix}>
                {Object.entries(selectedMixable).length === 0 && (
                      <Option placeholder value={-1} name="Välj kategori" />
                )}
                {mixables.map((cat,index) => (
                    <Option key={cat.value} value={index} name={cat.text} />
                ))}
            </SelectInputNarrow>

          </div>
          <Spacer />
          <ProductList>
            {this.state.products.map((item,index) => (
                <ListItem key={index} mix={item.isMiscible} info={item.moreInfo} name={item.productName} />
            ))}
          </ProductList>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  preparations: state.preparations.preparations,
  mixables:state.mixables.mixables,
  selectedMixable:state.mixables.selected,
  selectedPreparation:state.preparations.selected
})

export default connect(mapStateToProps)(ThirdPage);
